<template>
	<div>
		<v-layout wrap row ma-2>
			<v-flex xs6 px-2 mt-2>
				<BaseSelect
					item-text="name"
					item-value="id"
					label="Estado de Sinc."
					:height="32"
					:items="statesSyncs"
					v-model="newSync"
					@input="$emit('get-value', { model: 'sync', value: $event })"
				/>
			</v-flex>
			<v-flex xs6 px-2 mt-4 v-if="newSync === 0">
				<button
					class="btn-seat btn-save"
					:disabled="disabled"
					type="button"
					@click="$emit('update-sync')"
				>
					Sincronizar
				</button>
			</v-flex>
		</v-layout>
		<v-layout wrap row justifiy-right ma-2 v-if="newSync === 0 && dataSync.length > 0">
			<v-flex xs12 px-2 mt-2 class="check">
				<label class="text-check" for="myCheckbox">Seleccionar Todo</label>
				<input
					type="checkbox"
					id="myCheckbox"
					:value="checkAll"
					:checked="checkAll"
					@change="selectedAll($event)">
			</v-flex>
		</v-layout>
		<div v-for="(info, index) in dataSync" class="container">
			<v-layout wrap>
				<v-flex xs12>
					<v-layout my-1>
						<v-flex xs4 pa-1 class="content-label">Referencia:</v-flex>
						<v-flex xs7 pa-1 class="content-text">{{ info.reference }}</v-flex>
						<v-flex xs1 pa-1 class="content-actions">
							<input
								v-if="newSync === 0"
								type="checkbox"
								v-model="info.isSelected"
								@change="itemSelected(info)">
							<app-tooltip-button
								color="error"
								class="mobile"
								icon='delete'
								text="Eliminar"
								:size="16"
								@click-icon="$emit('delete-seat-sync', info)"
							/>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<v-layout mb-1>
						<v-flex xs4 pa-1 class="content-label">Fecha:</v-flex>
						<v-flex xs8 pa-1 class="content-text">{{ info.date }}</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<v-layout mb-1>
						<v-flex xs4 pa-1 class="content-label">Asientos Relacionados</v-flex>
						<v-flex xs8 pa-1 class="content-text">{{ relatedAccountSeats(info.relationsSeatCode) }}</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<app-table
						:main-list="false"
						:input-search="false"
						:filter-columns="false"
						:columns="columnsSync"
						:rows="info.details">
						<template slot="rows" slot-scope="props">
							<td v-show="showRow(columnsSync, 1)" class="is-not-selectable account">{{ props.row.codeAccounting }}</td>
							<td v-show="showRow(columnsSync, 2)" style="text-align: right; padding: 0 5px;">{{ props.row.amountDebe | formatAmount }}</td>
							<td v-show="showRow(columnsSync, 3)" style="text-align: right; padding: 0 5px;">{{ props.row.amountHaber | formatAmount }}</td>
							<td v-show="showRow(columnsSync, 4)" style="text-align: right; padding: 0 5px;">{{ props.row.balance | formatAmount }}</td>
						</template>
					</app-table>
				</v-flex>
			</v-layout>
		</div>
		<section class="modal-filter-footer">
			<v-layout justify-center>
				<v-pagination
					:length="lastPage"
					:total-visible="totalVisible"
					:value="page"
					color="success"
					circle
					light
					@input="$emit('change-page', $event)"
				></v-pagination>
			</v-layout>
		</section>
	</div>
</template>

<script>
	import appTooltipButton from '@/components/shared/app-tooltip-button';

	function relatedAccountSeats(array) {
		return array.join(', ');
	}

	function selectedAll({ target }) {
		this.$emit('select-all-items', target.checked);
	}

	function itemSelected(item) {
		this.$emit('seleted-item', item);
	}

	function data() {
		return {
			columnsSync: [
				{ id: 1, name: 'Cód. cta. contable', value: 'code', checked: true, visible: true },
				{ id: 2, name: 'Debe', value: 'debit', checked: true, visible: true },
				{ id: 3, name: 'Haber', value: 'credit', checked: true, visible: true },
				{ id: 4, name: 'Total', value: 'balance', checked: true, visible: true },
			],
			newSync: null,
		};
	}
	export default {
		name: 'list-accounting-sync',
		data,
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			appTooltipButton,
		},
		methods: {
			relatedAccountSeats,
			selectedAll,
			itemSelected,
		},
		props: {
			dataSync: {
				type: Array,
				default: [],
			},
			statesSyncs: {
				type: Array,
				default: [],
			},
			sync: {
				type: Number,
				default: null,
			},
			checkAll: {
				default: false,
				type: Boolean,
			},
			disabled: {
				default: false,
				type: Boolean,
			},
			page: Number,
			lastPage: Number,
			totalVisible: {
				default: 5,
				type: Number,
			},
		},
		watch: {
			sync: {
				deep: true,
				immediate: true,
				handler(newVal) {
					this.newSync = newVal;
				},
			},
		},
	};
</script>

<style lang="scss" scoped>
.container {
	padding: 10px;
	margin-bottom: 19px;
}
.content-label {
	color: #2c404a;
	background-color: #e0e5e8;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 12px;
	font-weight: 500;
}

.content-text {
	background-color: white;
	font-family: map-get($fonts, AvenirRegular);
	font-size: 12px;
}
.content-actions {
	background-color: white;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.mobile {
	@media (max-width: 768px) {
		display: none;
	}
}
.check {
	display: flex;
	justify-content: right;
	gap: 1rem;
	align-items: center;
}
.text-check {
	color: color(grey-text);
	font-size: size(small);
	padding-top: 3px
}
.btn-seat {
	color: white;
	border-radius: 10px;
    font-family: 'AvenirRegular';
    font-size: 14px;
	padding: 5px 15px;

	&[disabled] {
		opacity: 0.5;
	}

	&.btn-save {
		background-color: color(secondary);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/journal/list-accounting-sync.vue